var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.PreviewWindow = new Class({
    Implements: [Options, Events],
    element: null,
    options: {
        selector_id: "product_preview_container",
        active_class: "active",
        close_preview_selector: 'i.product_preview_close',
        panel_selector: 'div.product_panel_options span',
        fullscreen_selector: 'div.product_panel_options i.full-screen'

    },
    bound_methods: {},
    initialize: function (ops) {
        this.setOptions(ops);
        this.bound_methods.on_hover_over_panel = this.on_hover_over_panel.bind(this);
        this.bound_methods.on_hover_out_panel = this.on_hover_out_panel.bind(this);
        this.bound_methods.on_click_close = this.on_click_close.bind(this);
        this.bound_methods.on_click_panel = this.on_click_panel.bind(this);
        this.bound_methods.on_click_fullscreen = this.on_click_fullscreen.bind(this);
        this.bound_methods.on_image_load = this.on_image_load.bind(this);
        this.element = document.id(this.options.selector_id);
        if (this.element) {
            var self = this.element.retrieve('menu_obj');
            if (self) {
                return self;
            } else {
                this.element.store('menu_obj', this);
            }
        }
    },
    hide: function () {
        if (this.element) {
            this.element.removeClass(this.options.active_class);
        }
    },
    show: function (element) {
        if (element) {
            this.content(element);
        }
        this.element.addClass(this.options.active_class);
        if (element) {
            this.position(element);
        }
    },
    position: function (el) {
        if (this.element) {
            var parent_li = el.getParent();
            if (parent_li && parent_li.hasClass('inline')) {
                // if the product is displayed inline, we want the preview 
                // window to line up to the outside of the dropdown window,
                // so we line up with the parent element
                el = parent_li.getParent();
            }
            var ref_dims = el.getCoordinates();
            var element_dims = this.element.getCoordinates();
            var window_size = window.getSize();
            var pos = {y: ref_dims.top, x: ref_dims.right};
            if ((ref_dims.right + element_dims.width) > window_size.x) {
                pos.x = ref_dims.left - element_dims.width;
            }
            if (window_size.y < (pos.y + element_dims.height)) {
                // Subtrack from the max window height the element height and the marquee height and the image height
                pos.y = window_size.y - (element_dims.height + 28);
            }
            this.element.setPosition(pos);
        }
        return this;
    },
    content: function (element) {
        if (this.element) {
            this.element.removeEvents();
            this.element.empty();
            var data = {
                entry_id: element.get('data-entry_id'),
                title: element.get('data-title'),
                product_thumbnail: element.get('data-product_thumbnail'),
                product_description: element.get('data-product_description'),
                product_type: element.get('data-product_type'),
            };
            data.panels = [];
            var current_state = OCS.WxBriefing.Functions.get_url_manager().current_url_state;
            if (current_state && current_state.panel_config) {
                for (var i = 1; i <= OCS.Constants.PANEL_LAYOUTS[OCS.WxBriefing.Functions.get_url_manager().current_url_state.panel_config].num_of_panels; i++) {
                    data.panels.push(i);
                }
            }
            var content = Elements.from(OCS.WxBriefing.Functions.get_template_manager().get_html('product_preview', data));
            content.inject(this.element);
            
            // Apply events
            this.element.getElements('img').addEvent('load', this.bound_methods.on_image_load);
            this.element.getElements(this.options.panel_selector).each(function (span) {
                span.hoverIntent({
                    over: this.bound_methods.on_hover_over_panel,
                    out: this.bound_methods.on_hover_out_panel
                });
                span.addEvent('click', this.bound_methods.on_click_panel);
            }.bind(this));
            this.element.getElements(this.options.fullscreen_selector).each(function (button) {
                button.addEvent('click', this.bound_methods.on_click_fullscreen);
            }.bind(this));
            this.element.getElements(this.options.close_preview_selector).each(function (button) {
                button.addEvent('click', this.bound_methods.on_click_close);
            }.bind(this));
            OCS.WxBriefing.Functions.get_product_drag().init_draggable();
        }
        return this;
    },
    on_click_close: function (e) {
        this.hide();
    },
    on_click_fullscreen: function (e) {
        var entry_id = e.target.getParent().get('data-entry_id');
        OCS.WxBriefing.Live.UI.show_product_fullscreen(OCS.WxBriefing.Functions.get_product_manager().get_product_by_entry_id(entry_id));
    },
    on_click_panel: function (e) {
        var entry_id = e.target.getParent().get('data-entry_id');
        var panel = e.target.get('text');
        var state = {};
        state['p' + panel] = {};
        state['p' + panel].entry_id = entry_id;
        OCS.WxBriefing.Functions.get_url_manager().update_url_state(state, 0);
        document.id('drop_panel_' + panel).removeClass('active');
        OCS.WxBriefing.Functions.get_product_drag().destroy_droppable();
        OCS.WxBriefing.Functions.get_ui_menu().reset_menu();
        this.fireEvent('product_selected', entry_id);
    },
    on_hover_over_panel: function (e) {
        OCS.WxBriefing.Functions.get_product_drag().init_droppable();
        var panel = e.target.get('text');
        document.id('drop_panel_' + panel).addClass('active');
    },
    on_hover_out_panel: function (e) {
        var panel = e.target.get('text');
        var drop = document.id('drop_panel_' + panel);
        if (drop) {
            drop.removeClass('active');
        }
        OCS.WxBriefing.Functions.get_product_drag().destroy_droppable();
    },
    on_image_load: function () {
        if (this.element) {
            var element_dims = this.element.getCoordinates();
            var window_size = window.getSize();
            if (window_size.y < (element_dims.bottom + 28)) {
                // Subtrack from the max window height the element height and the marquee height and the image height
                this.element.setPosition({x: element_dims.left, y: window_size.y - (element_dims.height + 28)});
            }
            this.element.getElements('img').removeEvent('load', this.bound_methods.on_image_load);
        }
    },
    destroy: function () {
        if (this.element) {
            this.element.store('menu_obj', null);
            this.element.removeEvent('click', this.bound_methods.on_click);
            this.element = null;
        }
        this.removeEvents();
    }

});
